export default __webpack_public_path__ + "static/media/FoodiAppScreens.cbc7df14.png";